const USERS_UPDATED = (state, users) => {
  state.users = users
}

export default {
  USERS_UPDATED,
}



// WEBPACK FOOTER //
// ./src/devicehq/store/modules/users/mutations.js